import { render, staticRenderFns } from "./Top.vue?vue&type=template&id=3dfa59fa&scoped=true"
import script from "./Top.vue?vue&type=script&lang=js"
export * from "./Top.vue?vue&type=script&lang=js"
import style0 from "./Top.vue?vue&type=style&index=0&id=3dfa59fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfa59fa",
  null
  
)

export default component.exports